<template>
  <div class="PVP">
    <ol>
      <li>
        <div>입구 앞 상자에서 랜덤으로 포장된 장비를 고릅니다</div>
        <div>사망자의 장비를 사용할 수 있습니다</div>
      </li>
      <li>경기는 3:3 팀전으로 진행되며 팀킬도 가능합니다</li>
      <li>마지막 생존자의 팀이 각각 30점씩 획득합니다</li>
      <li>팀 유니폼은 전투 투구 입니다</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'PVP'
}
</script>


// WEBPACK FOOTER //
// src/components/Mission/PVP.vue